import { type Component, For } from "solid-js";
import CheckIcon from "~/Icons/24_Icon_Checked.svg?component-solid";
import EventAnalytics from "~/js/utilities/EventAnalytics";
import { ButtonExtraBold } from "~/solidJs/shared";
import { ENTERPRISE_FEATURES } from "../model";

export const EnterpriseSection: Component = () => {
	return (
		<>
			{/* Mobile version - Two separate blocks */}
			<div class="flex flex-col gap-5 px-8 md:hidden">
				{/* First block - Header and Button */}
				<div class="flex w-full flex-col gap-12 rounded-3xl border border-border-secondary bg-background-gray-light p-6">
					<div class="flex flex-col gap-1">
						<h2 class="font-semibold text-2xl text-text-primary">Enterprise</h2>
						<p class="text-15-medium text-text-secondary">
							Tailored AI solutions for your organization
						</p>
					</div>
					<ButtonExtraBold
						onClick={() => EventAnalytics.checkoutInitiated("enterprise")}
						component={"a"}
						href="https://airtable.com/appT508YoSwEs5Euq/pag6t1MPpFLxmYLMi/form"
						target="_blank"
						variant="Secondary"
					>
						Contact Sales
					</ButtonExtraBold>
				</div>

				{/* Second block - Features List */}
				<div class="flex w-full flex-col gap-6 rounded-3xl border border-border-secondary bg-background-gray-light p-6">
					<div class="flex flex-col gap-1">
						<h3 class="font-semibold text-2xl text-text-primary">Why Enterprise ?</h3>
						<p class="text-15-medium text-text-secondary">Everything in Teams, and:</p>
					</div>
					<div class="flex flex-col gap-4">
						<For each={ENTERPRISE_FEATURES}>
							{(feature) => (
								<div class="flex items-start gap-1.5">
									<div class="size-5 flex-shrink-0">
										<CheckIcon class="size-5 text-text-primary" />
									</div>
									<span class="text-15-medium text-text-primary">{feature}</span>
								</div>
							)}
						</For>
					</div>
				</div>
			</div>

			{/* Desktop version - Single horizontal block */}
			<div class="custom-tw-hidden h-[420px] w-full flex-row gap-6 rounded-3xl border border-border-secondary bg-background-gray-light p-6 md:flex">
				{/* Left Section - Header and Features */}
				<div class="flex h-full flex-1 flex-col justify-between">
					<div class="flex flex-col gap-6">
						<div class="flex flex-col gap-0.5">
							<h2 class="header-20-semibold text-text-primary">Enterprise</h2>
							<p class="text-15-medium text-text-secondary">
								Tailored AI solutions for your organization
							</p>
						</div>
						<div class="header-48-medium text-text-primary">Custom</div>
					</div>
					<ButtonExtraBold
						onClick={() => EventAnalytics.checkoutInitiated("enterprise")}
						component={"a"}
						href="https://airtable.com/appT508YoSwEs5Euq/pag6t1MPpFLxmYLMi/form"
						target="_blank"
						variant="Secondary"
					>
						Contact Sales
					</ButtonExtraBold>
				</div>

				{/* Divider */}
				<div class="h-full w-px bg-border-tertiary" />

				{/* Features List */}
				<div class="flex flex-1 flex-col gap-2.5">
					<h3 class="caption-12-medium text-text-secondary">Everything in Teams, and:</h3>
					<For each={ENTERPRISE_FEATURES}>
						{(feature) => (
							<div class="flex items-center gap-2">
								<div class="size-4 flex-shrink-0">
									<CheckIcon class="size-4 text-text-primary" />
								</div>
								<span class="typography-text-14-medium text-text-primary">
									{feature}
								</span>
							</div>
						)}
					</For>
				</div>
			</div>
		</>
	);
};
